import { Stack, Text } from "@mantine/core";
import TripDrawerTravellerCard from "./TripDrawerTravellerCard";

const TripDrawerTravellers = ({ travellers = [], coverType, onTravellerClick }) => {
  if (!travellers.length) {
    return (
      <Text size="sm" c="dimmed">
        No travellers found.
      </Text>
    );
  }

  return (
    <Stack gap="md">
      {travellers.map((traveller) => (
        <TripDrawerTravellerCard
          key={traveller.id}
          traveller={traveller}
          coverType={coverType}
          onTravellerClick={onTravellerClick}
        />
      ))}
    </Stack>
  );
};

export default TripDrawerTravellers;
